export default __webpack_public_path__ + "static/media/CNRG.82c90711.png";